import isHotKey from 'is-hotkey';
import SlateHotkeys from 'slate-hotkeys';
import BlockTypes from '../../../types/BlockTypes';
import onArrowUp from './onArrowUp';
import onArrowDown from './onArrowDown';
import onEnter from './onEnter';
import onBackspace from './onBackspace';
import onDelete from './onDelete';
import onTab from './onTab';
import onSelectRight from './onSelectRight';
import onSelectLeft from './onSelectLeft';
import onSelectUp from './onSelectUp';
import onSelectDown from './onSelectDown';
import onSelectAll from './onSelectAll';
var isSplitBlock = SlateHotkeys.isSplitBlock,
    isDeleteBackward = SlateHotkeys.isDeleteBackward,
    isDeleteForward = SlateHotkeys.isDeleteForward,
    isDeleteWordBackward = SlateHotkeys.isDeleteWordBackward,
    isDeleteWordForward = SlateHotkeys.isDeleteWordForward,
    isMoveForward = SlateHotkeys.isMoveForward,
    isMoveLineForward = SlateHotkeys.isMoveLineForward,
    isMoveWordForward = SlateHotkeys.isMoveWordForward,
    isMoveBackward = SlateHotkeys.isMoveBackward,
    isMoveLineBackward = SlateHotkeys.isMoveLineBackward,
    isMoveWordBackward = SlateHotkeys.isMoveWordBackward,
    isExtendForward = SlateHotkeys.isExtendForward,
    isExtendBackward = SlateHotkeys.isExtendBackward,
    isExtendLineForward = SlateHotkeys.isExtendLineForward,
    isExtendLineBackward = SlateHotkeys.isExtendLineBackward;

var isMoveSelectionRight = function isMoveSelectionRight(event) {
  return isExtendForward(event) || isHotKey('mod?+opt?+shift+right', event);
};

var isMoveSelectionLeft = function isMoveSelectionLeft(event) {
  return isExtendBackward(event) || isHotKey('mod?+opt?+shift+left', event);
};

var isMoveSelectionUp = function isMoveSelectionUp(event) {
  return isExtendLineBackward(event) || isHotKey('mod?+opt?+shift+up', event);
};

var isMoveSelectionDown = function isMoveSelectionDown(event) {
  return isExtendLineForward(event) || isHotKey('mod?+opt?+shift+down', event);
};

var isAddingColumnAfter = function isAddingColumnAfter(event) {
  return isHotKey('mod+ctrl+right', event);
};

var isAddingColumnBefore = function isAddingColumnBefore(event) {
  return isHotKey('mod+ctrl+left', event);
};

var isResetSelectionAtStart = function isResetSelectionAtStart(event) {
  return isMoveBackward(event) || isMoveLineBackward(event) || isMoveWordBackward(event) || isHotKey('up', event);
};

var isResetSelectionAtEnd = function isResetSelectionAtEnd(event) {
  return isMoveForward(event) || isMoveLineForward(event) || isMoveWordForward(event) || isHotKey('down', event);
};

function isTypingEvent(event) {
  return !event.metaKey && !event.ctrlKey && event.key.length === 1;
}

function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}

function handleWhenTableIsSelected(event, editor, next, store) {
  var tableId = store.getItem('lastFocusedTableId');

  if (isHotKey('mod+a', event)) {
    stopEvent(event);
    return editor.selectTable(tableId);
  } else if (isHotKey('escape', event)) {
    return editor.deselectTable();
  } else if (isMoveSelectionRight(event)) {
    return onSelectRight(event, editor, next);
  } else if (isMoveSelectionLeft(event)) {
    return onSelectLeft(event, editor, next);
  } else if (isMoveSelectionUp(event)) {
    return onSelectUp(event, editor, next);
  } else if (isMoveSelectionDown(event)) {
    return onSelectDown(event, editor, next);
  } else if (isDeleteBackward(event) || isDeleteWordBackward(event) || isDeleteForward(event) || isDeleteWordForward(event)) {
    var tableSelection = store.getItem(tableId);

    if (!editor.isTableCellsEmpty(editor.getSelectedTableCells())) {
      return editor.emptyTableCells(editor.getSelectedTableCells());
    } else if (tableSelection.selected) {
      return editor.removeTable(tableId);
    } else if (tableSelection.selectedColumnIndex >= 0 && editor.canRemoveTableColumn(tableId)) {
      return editor.removeTableColumn(tableId, tableSelection.selectedColumnIndex);
    } else if (tableSelection.selectedRowIndex >= 0 && editor.canRemoveTableRow(tableId)) {
      return editor.removeTableRow(tableId, tableSelection.selectedRowIndex);
    }

    return editor;
  } else if (isResetSelectionAtEnd(event)) {
    stopEvent(event);
    var cell = editor.getSelectedTableCells().last();
    return editor.moveToEndOfNode(cell);
  } else if (isResetSelectionAtStart(event)) {
    stopEvent(event);

    var _cell = editor.getSelectedTableCells().first();

    return editor.moveToStartOfNode(_cell);
  } else if (isTypingEvent(event)) {
    var _cell2 = editor.getSelectedTableCells().first();

    editor.emptyTableCell(_cell2).moveToStartOfNode(_cell2).focus();
  }
}

function handleWhenSelectionIsInTable(event, editor, next) {
  if (isHotKey('mod+a', event)) {
    return onSelectAll(event, editor, next);
  } else if (isMoveSelectionRight(event)) {
    return onSelectRight(event, editor, next);
  } else if (isMoveSelectionLeft(event)) {
    return onSelectLeft(event, editor, next);
  } else if (isMoveSelectionUp(event)) {
    return onSelectUp(event, editor, next);
  } else if (isMoveSelectionDown(event)) {
    return onSelectDown(event, editor, next);
  } else if (isHotKey('down', event)) {
    return onArrowDown(event, editor, next);
  } else if (isHotKey('up', event)) {
    return onArrowUp(event, editor, next);
  } else if (isSplitBlock(event) || isHotKey('alt?+ctrl?+enter', event)) {
    return onEnter(event, editor, next);
  } else if (isDeleteBackward(event) || isDeleteWordBackward(event)) {
    return onBackspace(event, editor, next);
  } else if (isDeleteForward(event) || isDeleteWordForward(event)) {
    return onDelete(event, editor, next);
  } else if (isHotKey('tab', event) || isHotKey('shift+tab', event)) {
    return onTab(event, editor, next);
  } else if (editor.value.selection.isExpanded && editor.value.anchorBlock !== editor.value.focusBlock && isTypingEvent(event)) {
    editor.emptyTableCellsAtSelection();
    return next();
  } else if (isAddingColumnAfter(event)) {
    return editor.addTableColumnAfter();
  } else if (isAddingColumnBefore(event)) {
    return editor.addTableColumnBefore();
  }

  return next();
}

function handleWhenSelectionIsNotInTable(event, editor, next) {
  if (isHotKey('down', event)) {
    var nextBlock = editor.value.document.getNextBlock(editor.value.endBlock.key);

    if (nextBlock && nextBlock.type === BlockTypes.TABLE_CELL) {
      return onArrowDown(event, editor, next);
    }
  } else if (isHotKey('up', event)) {
    var previousBlock = editor.value.document.getPreviousBlock(editor.value.startBlock.key);

    if (previousBlock && previousBlock.type === BlockTypes.TABLE_CELL) {
      return onArrowUp(event, editor, next);
    }
  }

  return next();
}

export default function makeOnKeyDown(store) {
  return {
    onKeyDown: function onKeyDown(event, editor, next) {
      if (store.getItem('lastFocusedTableId')) {
        var handled = handleWhenTableIsSelected(event, editor, next, store);
        if (handled) return handled;
      }

      if (editor.value.selection.isUnset) return next();

      if (!editor.isSelectionInTable()) {
        return handleWhenSelectionIsNotInTable(event, editor, next);
      } else {
        return handleWhenSelectionIsInTable(event, editor, next);
      }
    },
    onDocumentKeyDown: function onDocumentKeyDown(event, editor) {
      // If a table is selected, forward the event to the editor middlewares
      if (store.getItem('lastFocusedTableId')) {
        return editor.run('onKeyDown', event);
      }
    }
  };
}